import React from "react";
import phoneImage from "../../images/iPhone 15 Pro.svg";

const inter = { fontFamily: "Inter, sans-serif" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const BULLETS_LEFT = ["Open an account in minutes", "Transfer money instantly"];
const BULLETS_RIGHT = ["Apply for loans easily", "Buy airtime & data fast"];

const CheckIcon = () => (
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		style={{ flexShrink: 0 }}
	>
		<circle cx="9" cy="9" r="9" fill="#295B4A" />
		<path
			d="M5 9.5l2.5 2.5 5.5-5.5"
			stroke="white"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</svg>
);

const AppleIcon = () => (
	<svg
		width="16"
		height="20"
		viewBox="0 0 814 1000"
		fill="white"
		xmlns="http://www.w3.org/2000/svg"
		style={{ flexShrink: 0 }}
	>
		<path d="M788.1 340.9c-5.8 4.5-108.2 62.2-108.2 190.5 0 148.4 130.3 200.9 134.2 202.2-.6 3.2-20.7 71.9-68.7 141.9-42.8 61.6-87.5 123.1-155.5 123.1s-85.5-39.5-164-39.5c-76 0-103.7 40.8-165.9 40.8s-105-57.8-155.5-127.4C46 790.7 0 663 0 541.8c0-207.5 135.4-317.3 269-317.3 70.1 0 128.4 46.4 172.5 46.4 42.8 0 109.8-49.1 189.2-49.1zM555.5 80c3.8-21.6 5.7-43.3 5.7-65s-3.8-43.3-5.7-65c-4.5.6-9 1.3-13.5 2C488.4-39.2 425.5 1.7 393 46c-24.1 31.2-47.2 79.7-47.2 129.3 0 19.9 3.3 39.8 5.7 46.2 2.5.6 6.4 1.3 10.2 1.3 42.8 0 103.1-40.1 137.2-102.7z" />
	</svg>
);

const GooglePlayIcon = () => (
	<svg
		width="16"
		height="18"
		viewBox="0 0 24 24"
		xmlns="http://www.w3.org/2000/svg"
		style={{ flexShrink: 0 }}
	>
		<path d="M1.22 0L13.2 12 1.22 24 .5 23.4V.6L1.22 0z" fill="#EA4335" />
		<path d="M17.5 8.5L14.5 12l3 3.5 4-2.4c1.1-.65 1.1-1.7 0-2.35L17.5 8.5z" fill="#FBBC04" />
		<path d="M1.22 0l12.98 12-3.5 3.5L.5.6 1.22 0z" fill="#34A853" />
		<path d="M1.22 24l9.98-9.98 3.5 3.5L1.22 24z" fill="#4285F4" />
	</svg>
);

const BulletItem = ({ text }) => (
	<div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
		<CheckIcon />
		<span
			style={{
				fontFamily: "'Geist', sans-serif",
				fontWeight: 400,
				fontSize: "clamp(13px, 1.11vw, 16px)",
				lineHeight: "1.5",
				color: "#5E5E5E",
			}}
		>
			{text}
		</span>
	</div>
);

const DownloadApp = () => {
	return (
		<>
			<style>{`
				@media (max-width: 767px) {
					.download-inner {
						flex-direction: column !important;
						padding: 60px 24px 0 24px !important;
						gap: 0 !important;
					}
					.download-text {
						max-width: 100% !important;
						margin-top: 0 !important;
						padding-bottom: 0 !important;
					}
					.download-phone {
						width: 100% !important;
						max-width: 390px !important;
						align-self: center !important;
						margin-top: 8px !important;
					}
					.download-bullets {
						flex-direction: column !important;
						gap: 12px !important;
					}
					.download-store-buttons {
						gap: 8px !important;
					}
					.download-store-buttons-mobile {
						display: flex !important;
						gap: 8px !important;
						padding: 24px 24px 40px 24px !important;
					}
					.download-store-buttons-desktop {
						display: none !important;
					}
				}
			`}</style>

			<section
				style={{
					width: "100%",
					background: "linear-gradient(0deg, #FFFFFF 0%, #F6F4EE 100%)",
					boxSizing: "border-box",
					overflow: "hidden",
				}}
			>
				<div
					className="download-inner"
					style={{
						maxWidth: "1440px",
						margin: "0 auto",
						display: "flex",
						alignItems: "flex-end",
						justifyContent: "space-between",
						paddingTop: "clamp(40px, 4.17vw, 60px)",
						paddingBottom: 0,
						paddingLeft: "clamp(20px, 5.56vw, 80px)",
						paddingRight: "clamp(10px, 2.85vw, 41px)",
						boxSizing: "border-box",
						gap: "clamp(24px, 2.78vw, 40px)",
					}}
				>
					{/* Left — text + bullets + buttons */}
					<div
						className="download-text"
						style={{
							flex: "1 1 280px",
							minWidth: 0,
							maxWidth: "560px",
							display: "flex",
							flexDirection: "column",
							gap: "clamp(20px, 2.22vw, 32px)",
							marginTop: "clamp(24px, 3.33vw, 48px)",
							paddingBottom: "clamp(40px, 5.56vw, 80px)",
						}}
					>
						{/* Label */}
						<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
							<span
								style={{
									width: "8px",
									height: "8px",
									borderRadius: "50%",
									backgroundColor: "#295B4A",
									flexShrink: 0,
									display: "inline-block",
								}}
							/>
							<span
								style={{
									fontFamily: "'Geist Mono', monospace",
								fontWeight: 500,
								fontSize: "14px",
								lineHeight: "1",
								letterSpacing: "0.08em",
								color: "#295B4A",
								textTransform: "uppercase",
								}}
							>
								Zikora MFB App
							</span>
						</div>

						{/* Heading */}
						<h2
							style={{
								...instrumentSerif,
								fontWeight: 400,
								fontSize: "clamp(32px, 4.17vw, 60px)",
								lineHeight: "1.1",
								letterSpacing: "-0.01em",
								color: "#132A22",
								margin: 0,
							}}
						>
							Everything you need from your bank, now in your pocket.
						</h2>

						{/* Bullets — 2 columns */}
						<div
							className="download-bullets"
							style={{
								display: "flex",
								gap: "clamp(24px, 4.17vw, 60px)",
							}}
						>
							<div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
								{BULLETS_LEFT.map((text) => (
									<BulletItem key={text} text={text} />
								))}
							</div>
							<div style={{ display: "flex", flexDirection: "column", gap: "14px" }}>
								{BULLETS_RIGHT.map((text) => (
									<BulletItem key={text} text={text} />
								))}
							</div>
						</div>

						{/* Store buttons — hidden on mobile (shown below phone instead) */}
						<div
							className="download-store-buttons download-store-buttons-desktop"
							style={{
								display: "flex",
								alignItems: "center",
								gap: "12px",
								flexWrap: "wrap",
							}}
						>
							<a
								href="https://apps.apple.com/us/app/zikora/id6444196255"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									height: "44px",
									backgroundColor: "#000000",
									borderRadius: "10px",
									padding: "0 16px",
									display: "flex",
									alignItems: "center",
									gap: "8px",
									textDecoration: "none",
									boxSizing: "border-box",
									flexShrink: 0,
								}}
							>
								<AppleIcon />
								<span
									style={{
										...inter,
										fontWeight: 600,
										fontSize: "13px",
										lineHeight: "1",
										color: "#FFFFFF",
										whiteSpace: "nowrap",
									}}
								>
									Get on iPhone
								</span>
							</a>

							<a
								href="https://play.google.com/store/apps/details?id=com.clive.zikora"
								target="_blank"
								rel="noopener noreferrer"
								style={{
									height: "44px",
									backgroundColor: "#000000",
									borderRadius: "10px",
									padding: "0 16px",
									display: "flex",
									alignItems: "center",
									gap: "8px",
									textDecoration: "none",
									boxSizing: "border-box",
									flexShrink: 0,
								}}
							>
								<GooglePlayIcon />
								<span
									style={{
										...inter,
										fontWeight: 600,
										fontSize: "13px",
										lineHeight: "1",
										color: "#FFFFFF",
										whiteSpace: "nowrap",
									}}
								>
									Get on Android
								</span>
							</a>
						</div>
					</div>

					{/* Phone mockup */}
					<img
						className="download-phone"
						src={phoneImage}
						alt="Zikora MFB mobile app"
						style={{
							width: "clamp(200px, 45.7vw, 658px)",
							height: "auto",
							objectFit: "contain",
							flexShrink: 0,
							alignSelf: "flex-end",
						}}
					/>
				</div>

				{/* Store buttons — mobile only, below phone */}
				<div
					className="download-store-buttons-mobile"
					style={{ display: "none" }}
				>
					<a
						href="https://apps.apple.com/us/app/zikora/id6444196255"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							height: "36px",
							backgroundColor: "#000000",
							borderRadius: "8px",
							padding: "0 8px",
							display: "flex",
							alignItems: "center",
							gap: "4px",
							textDecoration: "none",
							boxSizing: "border-box",
						}}
					>
						<AppleIcon />
						<span style={{ ...inter, fontWeight: 600, fontSize: "10px", lineHeight: "1", color: "#FFFFFF", whiteSpace: "nowrap" }}>
							Get on iPhone
						</span>
					</a>
					<a
						href="https://play.google.com/store/apps/details?id=com.clive.zikora"
						target="_blank"
						rel="noopener noreferrer"
						style={{
							height: "36px",
							backgroundColor: "#000000",
							borderRadius: "8px",
							padding: "0 8px",
							display: "flex",
							alignItems: "center",
							gap: "4px",
							textDecoration: "none",
							boxSizing: "border-box",
						}}
					>
						<GooglePlayIcon />
						<span style={{ ...inter, fontWeight: 600, fontSize: "10px", lineHeight: "1", color: "#FFFFFF", whiteSpace: "nowrap" }}>
							Get on Android
						</span>
					</a>
				</div>
			</section>
		</>
	);
};

export default DownloadApp;
